// extracted by mini-css-extract-plugin
export default {"cardscale":"card_cardscale__5U9Ei"};